<div class="lv-artefact-container"
     [ngClass]="[!!uiArtefakt?.CardLayoutUIContainer && ((eventService.modalDialogGeoeffnet$ | async) === false) ? uiArtefakt?.CardLayoutUIContainer : '',
     !!uiArtefakt?.CardLayoutUIContainer && ((eventService.modalDialogGeoeffnet$ | async) === true) ? uiArtefakt?.CardLayoutUIContainer + 'Inline' : '',
     !!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung]">
  <div class="lv-artefact"
       [ngClass]="[!!uiArtefakt?.BreiteInPixel? uiArtefakt?.BreiteInPixel : 'Breite_Maximal',
       uiArtefakt?.Hervorhebungstyp ? uiArtefakt.Hervorhebungstyp : 'Normal']">
    <ng-container *ngIf="!!uiArtefakt?.CardLayoutUIContainer">
      <lv-uiartefakt-container-header [text]="uiArtefakt.Text" [titel]="uiArtefakt.Titel"
                                      [cardLayout]="uiArtefakt.CardLayoutUIContainer"></lv-uiartefakt-container-header>
    </ng-container>
    <ng-container *ngIf="!uiArtefakt?.CardLayoutUIContainer">

      <div class="lv-gruppe-titel" *ngIf="uiArtefakt?.Titel"
           [innerHTML]="uiArtefakt?.Titel"></div>
    </ng-container>
    <ng-container *ngIf="expansionPanel">
      <mat-expansion-panel class="lv-material-expansion-panel">
        <mat-expansion-panel-header class="lv-material-expansion-panel-header">
          <mat-panel-description class="right-aligned">
            Details
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="lv-flex" [ngClass]="[uiArtefakt?.ArtefaktAnordnung ? uiArtefakt.ArtefaktAnordnung : 'Untereinander',
 !!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung]">
          <div class="lv-gruppe-content" [ngClass]="{'lv-gruppe-with-card-layout': !!uiArtefakt?.CardLayoutUIContainer}"
               *ngFor="let artefakt of uiArtefakt?.UIArtefakt,trackBy: trackByFn">
            <lv-uiartefakt-renderer [uiArtefakt]="artefakt"></lv-uiartefakt-renderer>
          </div>
        </div>
      </mat-expansion-panel>
    </ng-container>
    <ng-container *ngIf="!expansionPanel">
      <div class="lv-flex" [ngClass]="[uiArtefakt?.ArtefaktAnordnung ? uiArtefakt.ArtefaktAnordnung : 'Untereinander',
 !!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung]">
        <div class="lv-gruppe-content" [ngClass]="{'lv-gruppe-with-card-layout': !!uiArtefakt?.CardLayoutUIContainer}"
             *ngFor="let artefakt of uiArtefakt?.UIArtefakt,trackBy: trackByFn">
          <lv-uiartefakt-renderer [uiArtefakt]="artefakt"></lv-uiartefakt-renderer>
        </div>
      </div>
    </ng-container>
  </div>
</div>
